import React, { Component } from 'react';
import { Button, crudUpdateMany as crudUpdateManyAction } from 'react-admin';
import { connect } from 'react-redux';

class UploadBulkToFolio extends Component {
  handleClick = () => {
    const {
      basePath,
      resource,
      selectedIds,
      crudUpdateMany,
    } = this.props;

    crudUpdateMany(resource, selectedIds, {}, basePath);
  };

  render() {
    return (
      <Button label="Upload Bulk To Folio" onClick={this.handleClick} />
    );
  }
}

export default connect(undefined, { crudUpdateMany: crudUpdateManyAction })(UploadBulkToFolio);



// WEBPACK FOOTER //
// ./src/components/OfferOrder/UploadBulkToFolio.js